/* ---------------------------------------------------------------------------
   Chargement differe des images d'interaction.

   Deux familles d'images etaient telechargees au chargement de chaque page
   alors que personne ne les voit tant qu'il n'a rien fait :

   - l'image de survol de la carte produit, qui n'apparait qu'au passage de la
     souris, donc jamais sur un telephone ;
   - les images du nuancier de couleurs, cachees jusqu'a ce que le visiteur
     survole ou choisisse une autre teinte.

   Mesure sur la page d'accueil : 54 images de survol pour 758 Ko, et 51 images
   de nuancier pour 311 Ko. Sur mobile, les 758 Ko sont du gaspillage pur.

   Le principe : le Liquid pose le srcset dans des attributs data, et ce script
   le remet en place a la premiere interaction avec la carte. Une image portant
   data-deferred-min-width n'est hydratee qu'au-dessus de cette largeur d'ecran,
   ce qui exclut l'image de survol sur mobile.

   Pourquoi pas une balise <picture> avec une media query, qui aurait evite tout
   JavaScript : le survol repose sur un selecteur de voisinage
   (.product-item__primary-image:hover ~ img.product-item__secondary-image).
   Envelopper l'image casserait ce selecteur, donc elle doit rester un <img>
   frere direct.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (window.__lplDeferredMedia) return;
  window.__lplDeferredMedia = true;

  function hydrate(img) {
    if (img.dataset.deferredDone) return;

    var min = Number(img.dataset.deferredMinWidth || 0);
    /* en dessous du seuil on ne marque rien : si la fenetre s'elargit plus
       tard, une interaction suivante pourra encore hydrater l'image */
    if (min && window.innerWidth < min) return;

    var srcset = img.dataset.deferredSrcset;
    if (!srcset) return;

    img.dataset.deferredDone = '1';
    /* sizes doit etre pose avant srcset : le navigateur choisit sa source au
       moment ou srcset est affecte */
    if (img.dataset.deferredSizes) img.sizes = img.dataset.deferredSizes;
    img.srcset = srcset;
  }

  function hydrateCard(card) {
    if (!card) return;
    var imgs = card.querySelectorAll('img[data-deferred-srcset]');
    for (var i = 0; i < imgs.length; i++) hydrate(imgs[i]);
  }

  function fromEvent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    hydrateCard(t.closest('product-item'));
  }

  /* delegation sur le document : couvre les cartes ajoutees apres coup
     (filtres, pagination, quick view) sans observer le DOM */
  document.addEventListener('pointerover', fromEvent, { passive: true, capture: true });
  document.addEventListener('focusin', fromEvent, { capture: true });
  document.addEventListener('touchstart', fromEvent, { passive: true, capture: true });
})();
